import React, { useState } from 'react';
import './LandingPage.css';
import NewsPreview from './NewsPreview';

export default function LandingPage({ hasConsented, setHasConsented, handleGoogleLogin, handleSubmit, emailInput, setEmailInput, urlInput, setUrlInput, isLoading, emailSentTo, resetEmailSent, allowedLimit, isAmazonUrl }) {
  const [step, setStep] = useState(1);
  const [showVideo, setShowVideo] = useState(false);
  function next(event) {
    event.preventDefault();
    const input = document.getElementById('url-input');
    if (!isAmazonUrl(urlInput)) {
      input.setCustomValidity('Pega el enlace de un producto de Amazon.');
      input.reportValidity();
      return;
    }
    setStep(2);
    requestAnimationFrame(() => document.getElementById('email-input')?.focus());
  }
  return (
    <main className="start-page">
      <section className="start-hero" aria-labelledby="start-title">
        <div className="start-copy">
          <span className="start-eyebrow">TU LISTA. TU PRECIO.</span>
          <h1 id="start-title">Te avisamos cuando baje de precio en Amazon.</h1>
          <p>Pega el enlace del producto. Nosotros comprobamos su precio y te avisamos por email cuando detectamos una bajada.</p>
          <p className="start-perks">Hasta {allowedLimit} productos gratis · Sin contraseña</p>
        </div>
        <div className="start-card formulario-container">
          {emailSentTo ? (
            <div role="status" className="start-confirmation">
              <span className="start-eyebrow">SOLO QUEDA CONFIRMAR</span>
              <h2>Revisa tu correo</h2>
              <p>Hemos enviado un enlace a <strong>{emailSentTo}</strong>. Ábrelo para acceder y activar el seguimiento de tu producto.</p>
              <p>Si no lo ves, comprueba la carpeta de spam. Abre el enlace en este navegador para recuperar el producto que has elegido.</p>
              <button type="button" className="start-secondary" onClick={resetEmailSent}>Cambiar email o reenviar</button>
            </div>
          ) : (
            <form onSubmit={step === 1 ? next : handleSubmit}>
              <span className="start-eyebrow">PASO {step} DE 2</span>
              <h2>{step === 1 ? '¿Qué quieres seguir?' : '¿Dónde te avisamos?'}</h2>
              <label htmlFor="url-input">Enlace del producto de Amazon</label>
              <input id="url-input" type="url" required value={urlInput} onChange={e => { e.target.setCustomValidity(''); setUrlInput(e.target.value); }} placeholder="https://www.amazon.es/dp/…" autoComplete="off" />
              {step === 1 ? <>
                <button type="submit" className="start-primary">Crear mi alerta <span aria-hidden="true">↗</span></button>
                <p className="start-help">Después eliges email o Google para guardar tu alerta.</p>
              </> : <>
                <label htmlFor="email-input">Tu email</label>
                <input id="email-input" type="email" required autoComplete="email" value={emailInput} onChange={e => setEmailInput(e.target.value)} placeholder="tu@email.com" />
                <label className="start-consent"><input type="checkbox" required checked={hasConsented} onChange={e => setHasConsented(e.target.checked)} /><span>Acepto la <a href="/politica-privacidad" target="_blank" rel="noreferrer">Política de Privacidad</a> y los <a href="/terminos-condiciones" target="_blank" rel="noreferrer">Términos y Condiciones</a>.</span></label>
                <button type="submit" className="start-primary" disabled={isLoading}>{isLoading ? 'Procesando…' : 'Recibir enlace y activar alerta'}</button>
                <p className="start-help">Te enviaremos un enlace de acceso. No necesitas contraseña.</p>
                <div className="start-divider">o</div>
                <button type="button" className="start-secondary" disabled={isLoading || !hasConsented} onClick={handleGoogleLogin}>Continuar con Google</button>
                {!hasConsented && <p className="start-help">Acepta las condiciones para continuar con Google.</p>}
              </>}
            </form>
          )}
        </div>
      </section>
      {!emailSentTo && <NewsPreview onChoose={url => {
        setUrlInput(url);
        setStep(1);
        requestAnimationFrame(() => {
          const input = document.getElementById('url-input');
          input?.setCustomValidity('');
          input?.focus({ preventScroll: true });
          document.querySelector('.start-card')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }} />}
      <section className="start-how" aria-labelledby="start-how-title">
        <h2 id="start-how-title">Tu próxima compra, sin revisar precios a diario</h2>
        <ol>
          <li><span>01</span><h3>Elige tu producto</h3><p>Copia su enlace de Amazon.es o Amazon.com. Comprueba el modelo y la variante.</p></li>
          <li><span>02</span><h3>Guarda tu alerta</h3><p>Accede con Google o confirma el enlace que te enviamos por email.</p></li>
          <li><span>03</span><h3>Recibe el aviso</h3><p>Te escribimos cuando detectamos un precio inferior al último que te notificamos.</p></li>
        </ol>
        <p className="start-help">Las comprobaciones son periódicas, no en tiempo real. Puedes gestionar tus alertas desde tu cuenta.</p>
      </section>
      <section className="start-learn">
        <h2>¿Necesitas una mano?</h2>
        <a href="/blog/como-rastrear-ofertas-amazon">Cómo crear una alerta e interpretar el histórico →</a>
        <button type="button" className="start-video-button" onClick={() => setShowVideo(!showVideo)} aria-expanded={showVideo} aria-controls="start-tutorial">{showVideo ? 'Ocultar tutorial' : 'Ver tutorial en vídeo'}</button>
        {showVideo && <video id="start-tutorial" controls preload="metadata" src="/avisamesibaja.mp4" />}
      </section>
    </main>
  );
}
